import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLang } from "../i18n";

export const Footer = () => {
    const { t } = useLang();
    return (
        <footer className="relative border-t border-lakou-gold/15 overflow-hidden bg-lakou-void">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <span data-testid="footer-logo" className="font-display font-black text-2xl tracking-[0.22em] text-goldgrad">LAKOU</span>
                        <p className="mt-4 max-w-sm text-sm text-lakou-grey leading-relaxed">
                            A Haitian-born cultural and musical experience. Afro House, Amapiano, Haitian music — {t("footer_line").toLowerCase()}.
                        </p>
                        <div data-testid="footer-social-links" className="mt-6">
                            <a
                                href="https://instagram.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LAKOU on Instagram"
                                data-testid="footer-instagram"
                                className="inline-flex w-11 h-11 rounded-full border border-lakou-gold/25 items-center justify-center text-lakou-offwhite hover:border-lakou-gold hover:text-lakou-gold transition-colors duration-300"
                            >
                                <Instagram size={18} />
                            </a>
                        </div>
                    </div>
                    <div className="md:col-span-2">
                        <div className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-lakou-sand mb-4">Explore</div>
                        <div className="space-y-2.5 text-sm">
                            {[["/", "Home"], ["/about", "About"], ["/event", "The Event"], ["/tickets", "Tickets"], ["/vote", "Your City"]].map(([to, label]) => (
                                <Link key={to} to={to} className="block text-lakou-offwhite hover:text-lakou-gold transition-colors">{label}</Link>
                            ))}
                        </div>
                    </div>
                    <div className="md:col-span-2">
                        <div className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-lakou-sand mb-4">More</div>
                        <div className="space-y-2.5 text-sm">
                            {[["/gallery", "Gallery"], ["/journal", "Journal"], ["/partners", "Partner With Us"], ["/contact", "Contact"]].map(([to, label]) => (
                                <Link key={to} to={to} className="block text-lakou-offwhite hover:text-lakou-gold transition-colors">{label}</Link>
                            ))}
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <div className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-lakou-sand mb-4">Legal</div>
                        <div className="space-y-2.5 text-sm">
                            {[["/privacy", "Privacy Policy"], ["/terms", "Terms of Service"], ["/refunds", "Ticket Refund Policy"]].map(([to, label]) => (
                                <Link key={to} to={to} className="block text-lakou-offwhite hover:text-lakou-gold transition-colors">{label}</Link>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-16 select-none pointer-events-none" aria-hidden="true">
                    <div className="font-display font-black text-[19vw] leading-[0.78] text-center text-stroke-gold opacity-25 tracking-tight">LAKOU</div>
                </div>

                <div data-testid="footer-copyright" className="mt-10 pt-6 border-t border-lakou-gold/10 flex flex-col sm:flex-row justify-between gap-3 font-mono2 text-[10px] uppercase tracking-[0.25em] text-lakou-sand">
                    <span>© 2026 LAKOU</span>
                    <span className="text-lakou-gold/70">{t("footer_line")}</span>
                </div>
            </div>
        </footer>
    );
};
